<template>
	<div class="input_warn_body" :class="{input_warn_body2: level == 2 ? true : false}" :style="sty">
		<img src="../../mycomponents/img/dialog/icon_cwts@2x.png" alt="" />{{ mess }}
	</div>
</template>

<script>
export default {
	props: {
		window_x: {type: Number},
		window_y: {type: Number},
		mess: {type: String},
		level: {type: Number},
	},
	computed: {
		sty() {
			// console.log("this.value * 100=", this.value * 100);
			// console.log("progress", this.value);
			return {
				left: this.window_x + "rem",
				top: this.window_y + "rem",
			};
		},
	},
	methods: {},
};
</script>

<style lang="less">
.input_warn_body {
	cursor: pointer;
	// background-color: white;
	background-image: url("../../mycomponents/img/dialog/pic_1@2x.png");
	// background-position: -5rem -5rem;
	background-repeat: no-repeat;
	background-size: 128rem 68rem;
	width: 128rem;
	height: 68rem;
	opacity: 1;
	position: fixed;
	z-index: 99999;
	font-size: 12rem;
	font-family: Source Han Sans CN;
	font-weight: 300;
	// line-height: 28rem;
	color: #1b212e;
	// letter-spacing: 2rem;
	opacity: 1;
	display: flex;
	align-items: center;
	// justify-content: center;
	white-space: nowrap;
	transform: translateX(-30rem) translateY(-5rem);
	img {
		display: inline-block;
		width: 14rem;
		height: 14rem;
		margin-right: 6rem;
		margin-left: 24rem;
	}
}
.input_warn_body2 {
	background-image: url("./../../mycomponents/img/dialog/pic_2@2x.png");
	background-size: 178rem 68rem;
	width: 178rem;
}
</style>
